export const WIFI_BACKUP_PRODUCT_ID = '48120';
export const MAX_LENGTH = 31;
export const MIN_SCREEN_SIZE = 408;
export const Address_Change = 'Change';
export const STREAM_TV_PRODUCT_ID = 'acc13960007';
export const APPLY_OFFER = 'apply offer';
export const FWA_DIGITAL = 'FWA-Digital';
export const FWA_ENHANCEMENTS_CFG_PROFILE = 'FwaenhancementsCfgProfile';
export const GIFT_CARD_OFFER_AAL_FFLAG = 'giftCardOfferAALFFlag';
export const GIFT_CARD_OFFER_NSE_FFLAG = 'giftCardOfferNSEFFlag';
